'use client';

import HomeTitle from '@/components/home/home-title';
import { getImageByLocale } from '@/utils/config';
import { useEffect, useMemo } from 'react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { CategoryCard } from '../cards';

const CategoriesSlider = ({
  data,
  locale,
  isMobile,
  fromPLP,
  fromCategories,
  fromHome,
  currentCategoryUrl,
}) => {
  const activeKey = isMobile ? 'mobile-active' : 'active';
  const posKey = isMobile ? 'mobile-position' : 'position';

  const activeData = useMemo(() => {
    const list = Array.isArray(data?.value) ? data.value : [];
    return list
      .filter((item) => (fromPLP ? true : item?.[activeKey]))
      .sort((a, b) => +(a?.[posKey] ?? 1e9) - +(b?.[posKey] ?? 1e9));
  }, [data?.value, fromPLP, activeKey, posKey]);

  useEffect(() => {
    if (activeData && activeData.length > 0) {
      const isFeaturedCategory = data?.key === 'featured-categories';

      if (isFeaturedCategory) {
        const storedData = localStorage.getItem('featured-categories');
        if (!storedData) {
          localStorage.setItem(
            'featured-categories',
            JSON.stringify({ value: activeData })
          );
        }
      }
    }
  }, [activeData, data?.key]);

  if (!activeData?.length) return null;

  return (
    <section className='mt-4 flex flex-col gap-2.5 sm:mt-5.5 md:mt-7 lg:mt-9'>
      {data?.[`title-${locale}`] && (
        <HomeTitle
          title={data?.[`title-${locale}`]}
          link={data?.url}
          linkTitle={locale === 'en' ? 'Show All' : 'عرض الكل'}
        />
      )}
      <div className='flex-1'>
        <Swiper
          className='categories-slider'
          key={locale}
          dir={locale === 'en' ? 'ltr' : 'rtl'}
          breakpoints={{
            320: { spaceBetween: 20, slidesPerView: 2.5 },
            640: { spaceBetween: 20, slidesPerView: 4 },
            768: { spaceBetween: 20, slidesPerView: 5 },
            1024: { spaceBetween: 20, slidesPerView: 7 },
            1440: { spaceBetween: 20, slidesPerView: 8 },
            1600: { spaceBetween: 20, slidesPerView: 9 },
          }}
          // loop
          slidesPerView='auto'
          modules={[Autoplay, Pagination]}
          pagination={{ enabled: true, clickable: true }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
          }}
        >
          {activeData?.map((info, index) => (
            <SwiperSlide key={index}>
              {' '}
              <CategoryCard
                target={
                  !fromPLP
                    ? info?.['open-in-new-tab']
                      ? '_blank'
                      : '_self'
                    : '_self'
                }
                img={
                  !fromPLP
                    ? getImageByLocale(info, locale, isMobile)
                    : process.env.NEXT_PUBLIC_IMG_BASEURL +
                      info?.['category_mobile_image1']
                }
                title={
                  !fromPLP
                    ? info?.[`title-${locale}`]
                    : info?.name || info?.[`title-${locale}`]
                }
                link={
                  currentCategoryUrl
                    ? `/c/${currentCategoryUrl}/${info?.url || info?.innova_url}`
                    : `/c/${info?.url || info?.innova_url}`
                }
                fromCategoriesSlider
                clickLocation={
                  fromPLP
                    ? 'plp_subcategory_tiles'
                    : fromCategories
                      ? 'categories_index'
                      : 'hp_featured_categories'
                }
                fromHome={fromHome}
                fromCategories={fromCategories}
                fromPLP={fromPLP}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default CategoriesSlider;
